import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import type { UpsellServices } from "../server/supabase-account-service";
import { SupabaseUpsellServices } from "../server/supabase-account-service";

export const useUpsellServices = (): UseSupabaseLoaderState<UpsellServices> => {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    const { data, error } = await new SupabaseUpsellServices(supabase).get(account_id);
    if (error) {
      throw new Error(`Failed to load account: ${error.message}`);
    }

    return data;
  }, []);
};
